import { gql } from '@apollo/client';

export const GET_HUBPRODUCTS = gql`
  query GetHubProducts($context: RequestContext!) {
    hubProducts(context: $context) {
      id
      listing {
        title
        description
        image {
          thumbnailUrl
        }
      }
      price {
        currency
        value
      }
      slug
      productCategoryShortname
      taxons {
        code
        name
      }
    }
  }
`;
